import { Component, ElementRef, Renderer2, ViewChild, AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { BaseServiceService } from "src/app/services/base-service.service";
import { Proceso } from "../diagram/diagram.component";
import { ModalNotifyComponent, ModalNotifyTypes } from "../modal-notify/modal-notify.component";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Subject, lastValueFrom } from "rxjs";
import { AppData } from "src/app/helpers/app-data";
import { ApiResponse } from "src/app/interfaces/generalInterfaces";

declare var fabric: any;

@Component({
  selector: "app-tareas",
  templateUrl: "./tareas.component.html",
  styleUrls: ["./tareas.component.css"],
})
export class TareasComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  dialogComponentCreate: any;
  dialogComponentAprobar: any;
  dialogComponentEdit: any;
  formSubmitted: boolean = false;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  idProceso: any;
  idEjecucionTarea;
  idEjecucionProcesoDetalle: any;
  IsCancelProcess: boolean = false;
  dialogComponentCancelarProceso: any;
  cancelProcessForm: FormGroup;
  viewObs: boolean = false;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtInstance: DataTables.Api;

  dtOptions: DataTables.Settings = {};
  dtOptButtons: any = [];
  getDataTableTareas: any = ["EjecucionTarea", "GetDataTableEjecucionTarea"];

  response: any[] = [];
  titulo: string = "";
  internalDescription: string = "";

  valorCompartido: any;
  validateDel: boolean = false;
  idTarea: Number;
  idTareaAprobada: Number;
  intervalId: any;
  updateInterval = 100; // Intervalo de actualización del progreso en milisegundos 
  progressPercent = 0;
  progressBar: HTMLElement;
  progressContainer: HTMLElement;

  getsDataTableTareas: string = "EjecucionTarea/GetDataTableEjecucionTarea";

  dtOptionsReady: boolean = false;
  buscarPorVariables: boolean = false;
  tableVisible: boolean = true;

  columnas = [
    { title: "ID", data: "Id" },
    { title: "Nombre Proceso", data: "NombreProceso" },
    { title: "Tarea", data: "NombreTarea" },
    { title: "Estado", data: "EstadoEjecucion" },
    { title: "Fecha Asignación", data: "FechaAsignacion" },
    { title: "Fecha Expiración", data: "FechaExpira", defaultContent: "Sin vencimiento", render: (d: any) => d ?? "Sin vencimiento" },
    { title: "Desviacion", data: "Desviacion" },
  ];

  constructor(
    private baseService: BaseServiceService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient,
    private elementRef: ElementRef,
    private _formBuilder:FormBuilder
  ) {}

  async ngOnInit(): Promise<void> {
    this.dtOptButtons.push({'button-id': 'btnVerFormulario', 'button-icon': 'ms-Icon--View', 'conditional-data': [
      { key: 'proceso-id', value: 'IdEjecucionProceso' },
      { key: 'formulario-id', value: 'IdFormulario' }
    ], "button-tooltip": "Ver Formulario" },
    {'button-id': 'btnCancelarTarea', 'button-icon': 'ms-Icon--StatusCircleBlock', 'conditional-data': [
      { key: 'procesodetalle-id', value: 'IdEjecucionProcesoDetalle' }
    ], "button-tooltip": "Cancelar Tarea" });

    this.cancelProcessForm = this._formBuilder.group({
      Observacion: new FormControl('', [Validators.required, Validators.maxLength(1000)])
    });

    this.progressBar = document.getElementById('progressBar');
    this.progressContainer = document.getElementById('progressContainer');

    this.startProgressCycle();
  }

  startProgressCycle() {
    setTimeout(() => {
      this.showProgressBar();
    }, AppData.tiempo_refresh_Tareas);
  }

  showProgressBar() {
    this.progressPercent = 0;
    this.progressContainer.style.display = 'block';
    const totalUpdates = 2000 / this.updateInterval; // 2 segundos de progreso

    const updateProgress = () => {
      this.progressPercent += 100 / totalUpdates;
      this.progressBar.style.width = this.progressPercent + '%';

      if (this.progressPercent >= 100) {
        clearInterval(this.intervalId);
        setTimeout(() => {
          this.hideProgressBar();
        }, 1000); // Espera 1 segundo antes de ocultar el loader y recargar la tabla
      }
    };

    this.intervalId = setInterval(updateProgress, this.updateInterval);
  }

  hideProgressBar() {
    this.progressContainer.style.display = 'none';
    this.reloadDataTable();
    this.startProgressCycle();
  }

  async ngAfterViewInit(): Promise<void> {
    this.dtInstance = await this.dtElement.dtInstance;
    this.dtInstance.on('draw', () => {
      // Aquí puedes agregar cualquier lógica que necesites ejecutar después de que se dibuje la tabla
    });

    this.elementRef.nativeElement.addEventListener("click", (event) => {
      if (event.target.id === "btnDescargarDocumento") {
        const id = parseInt(event.target.getAttribute("data-id"));
        this.descargarDocumentoValidacion(id);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.dtInstance) {
      this.dtInstance.off("draw");
    }

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  gridLoaded(event: any) {
    this.dtInstance = event['table'];
  }

  customClick(event: any) {
    try {
      let idEjecucionTarea = event["data-id"];
      let formSubmitted = event["data-formulario-id"];
      let idEjecucionProceso = event["data-proceso-id"];
      this.idEjecucionProcesoDetalle = event["data-procesodetalle-id"];

      switch (event['button-id']) {
        case 'btnVerFormulario':
          this.baseService.exportIDForm(formSubmitted);
          this.baseService.exportIdEjecucionProceso(idEjecucionProceso);
          this.baseService.exportIdEjecucionTarea(idEjecucionTarea);

          this.router.navigate(["home/formulario"]);
          break;
        case 'btnCancelarTarea':
  
            this.IsCancelProcess = true;
            this.viewObs = false;
    
            const dialogSendActionProcess = document.querySelector(".cancel-observation");
            this.dialogComponentCancelarProceso = new fabric["Dialog"](dialogSendActionProcess);
            this.dialogComponentCancelarProceso.open();

            break;
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  clearCancelForm()
  {
    this.cancelProcessForm.reset();
  }

  async enviarAccionProceso()
  {

    const response = await lastValueFrom(this.http.post<any>(AppData.API_URL+"EjecucionProceso/AccionProceso?IdEjecucionDetalle="+this.idEjecucionProcesoDetalle+"&IsCancel="+this.IsCancelProcess+'&Observacion='+(this.IsCancelProcess ? this.cancelProcessForm.get('Observacion').value : null), null));

    if (!response.Ok) {

      let mensajeError = "<ul>";
      response.ValidationErrors.forEach((error: any) => {
        mensajeError += `<li>${error}</li>`;
      });
      mensajeError += "</ul>";

      this.baseService.triggerShowModal(
        "Error al cancelar proceso",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      
    } else {

      if(this.IsCancelProcess)
      {
        this.dialogComponentCancelarProceso.close();
      }

      this.baseService.triggerShowModal(
        "Proceso cancelado",
        "Proceso cancelado exitosamente",
        ModalNotifyTypes.Success,
        false
      );

      this.reloadDataTable();
      
    }

    this.cancelProcessForm.reset();

  }

  async descargarDocumentoValidacion(idArchivo: number) {
    try {
      const responseDocumentos = await lastValueFrom(
        this.http.get<any>(
          AppData.API_URL +
            `EjecucionProceso/DocumentosEjecucionProceso?IdEjecucion=${this.idEjecucionTarea}`
        )
      );

      const ejecucionProcesoObj = responseDocumentos.Data.find(
        (item: any) => item.Id === idArchivo
      );

      if (!ejecucionProcesoObj) {
        console.error(`Documento con Id ${idArchivo} no encontrado`);
        return;
      }
      this.descargarDocumentoGeneral(
        idArchivo,
        ejecucionProcesoObj.NombreDocumento
      );
    } catch (error) {
      console.error("Error obteniendo la lista de documentos", error);
    }
  }

  async descargarDocumentoGeneral(idArchivo: number, NombreDocumento: string) {
    try {
      const response = await lastValueFrom(
        this.http.get(
          AppData.API_URL +
            `EjecucionProceso/DescargarDocumento?IdArchivo=${idArchivo}`,
          { responseType: "blob" }
        )
      );
      const url = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = url;
      a.download = NombreDocumento;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error descargando el documento", error);
    }
  }

  reloadDataTable(): void {
   /*  this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload(null, false);
    }); */
    this.dtInstance.ajax.reload(null,false)

  }

  onBuscarPorVariablesChange(): void {
    const endpoint = this.buscarPorVariables
      ? 'GetDataTableEjecucionTareaByVariables'
      : 'GetDataTableEjecucionTarea';
    this.getDataTableTareas = ['EjecucionTarea', endpoint];
    // Re-initialize the datatable with the new endpoint
    this.tableVisible = false;
    setTimeout(() => { this.tableVisible = true; }, 0);
  }
}
